import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const HEADER: BlockOverrides = {
  Block: {
    style: {
      marginTop: '48px',
      display: 'grid',
      gridTemplateColumns: '70% 1fr',
      gridColumnGap: '32px',
      marginBottom: '48px',
    },
  },
};

export const BUTTON_CONTAINER: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '8px',
    },
  },
};

export const TYPE: BlockOverrides = {
  Block: {
    style: {
      color: THEME.colors.mono600,
      marginTop: '8px',
    },
  },
};
